import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
//@ts-ignore
import * as Handlebars from 'handlebars/dist/cjs/handlebars';

@Directive({
  selector: '[sanitizeHtml]',
  standalone: true
})
export class SanitizeHtmlDirective implements OnInit {

  @Input()
  sanitizeHtml: any = '';

  @Input()
  data: any;

  constructor(private elemRef: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.renderer.setProperty(this.elemRef.nativeElement, 'innerHTML', this.getHtml());
  }

  getHtml(): string {
    if (!!this.data) {
      const template = Handlebars.compile(this.sanitizeHtml);
      return template(this.data);
    } else {
      return this.sanitizeHtml;
    }
  }

}
